import React from 'react';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { BsCashStack } from 'react-icons/bs';
import logo from '../../../../assets/Axiom-Logo.png';

export default function MobileMetroLevel1({
  getMainMenus,
  hasMenuAccess,
  handleSyncOfflinePack,
  syncingOfflinePack,
  online,
  activeProject,
  offlineSyncNote,
  myOpenPettyFunds,
  menusLoaded,
  handleNavigate,
  showProjectPicker,
  setShowProjectPicker,
  configuredProjects,
  handleQuickActivateProject,
  hasUnreadOpsChat,
  handleLevel1Click,
  hasProjects,
}) {
  const menus = getMainMenus();
  const projectPersonnelMenus = menus.filter((m) => m.section === 'project-personnel');
  const companyMenus = menus.filter((m) => m.section === 'company');
  const projectMenus = menus.filter((m) => m.section === 'project');

  return (
  <div className="mobile-metro-level mobile-metro-level-1">
    {/* Logo Header */}
    <div className="mobile-metro-logo-header-wrap">
      <div className="mobile-metro-logo-header">
        <img src={logo} alt="Logo" className="mobile-metro-logo-img" />
        <span className="mobile-metro-logo-text">ArchonPM</span>
      </div>
      {hasMenuAccess('/drilling/progress-map') && (
        <button
          type="button"
          className="mobile-metro-sync-btn"
          onClick={handleSyncOfflinePack}
          disabled={syncingOfflinePack || !online || !activeProject?.project_id}
          title="Sync Drill Progress Map data for offline use"
        >
          <FaCloudDownloadAlt className="me-1" />
          {syncingOfflinePack ? 'Syncing...' : 'Sync Offline'}
        </button>
      )}
    </div>
    {offlineSyncNote?.message && (
      <div className={`mobile-metro-sync-note ${offlineSyncNote.type || 'info'}`}>
        {offlineSyncNote.message}
      </div>
    )}

    {myOpenPettyFunds.length > 0 && menusLoaded && (
      <>
        <div className="mobile-metro-section-header">
          <div className="section-line" />
          <span className="section-label">MY PETTY CASH</span>
          <div className="section-line" />
        </div>
        <div className="mobile-metro-tiles" style={{ marginTop: '0.5rem' }}>
          {myOpenPettyFunds.map((f, idx) => (
            <div
              key={f.id}
              className="mobile-metro-tile"
              style={{
                backgroundColor: '#1a4d3a',
                animationDelay: `${idx * 50}ms`
              }}
              onClick={() => handleNavigate(`/finance/petty-cash/funds/${f.id}`)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleNavigate(`/finance/petty-cash/funds/${f.id}`)}
            >
              <BsCashStack className="tile-icon" />
              <div className="tile-title">{f.name}</div>
              <div style={{ fontSize: '0.7rem', opacity: 0.9, marginTop: 2, lineHeight: 1.2 }}>
                Register expenses · {f.currency}{' '}
                {typeof f.current_balance === 'number' ? f.current_balance.toFixed(2) : ''}
              </div>
            </div>
          ))}
        </div>
      </>
    )}

    {/* Project personnel only: show active project (read-only) and just the assigned module cards */}
    {projectPersonnelMenus.length > 0 && (
      <>
        {activeProject && (
          <div className="project-selector-info" style={{ padding: '0.5rem 0', color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem' }}>
            <span style={{ opacity: 0.8 }}>Project: </span>
            <span style={{ fontWeight: 600 }}>{activeProject.project_name}</span>
          </div>
        )}
        <div className="mobile-metro-tiles" style={{ marginTop: '0.5rem' }}>
        {projectPersonnelMenus.map((menu, idx) => {
          const isChatOffline = menu.id === 'operations-chat' && !online;
          return (
          <div
            key={menu.id}
            className="mobile-metro-tile"
            style={{
              backgroundColor: menu.color,
              animationDelay: `${idx * 50}ms`,
              ...(isChatOffline ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : {})
            }}
            onClick={() => {
              if (isChatOffline) return;
              if (menu.directPath) handleNavigate(menu.directPath);
              else if (menu.id) handleLevel1Click(menu.id);
            }}
          >
            <menu.icon className="tile-icon" />
            <div className="tile-title">{menu.title}</div>
            {menu.id === 'inventory-field-entry' && (
              <div style={{ fontSize: '0.7rem', opacity: 0.88, marginTop: 2, lineHeight: 1.2 }}>
                List · New asset
              </div>
            )}
            {menu.id === 'operations-chat' && hasUnreadOpsChat && (
              <span className="ops-chat-unread-dot mobile-metro-chat-dot" aria-label="Unread operations chat messages" />
            )}
          </div>
          );
        })}
        </div>
      </>
    )}

    {/* Project Quick Selector: only when user has Projects menu access and menus are loaded (not for project-personnel-only) */}
    {projectPersonnelMenus.length === 0 && menusLoaded && hasProjects && configuredProjects.length > 0 && hasMenuAccess('/projects') && (
      <div className="mobile-metro-project-selector">
        <div
          className="mobile-metro-project-current"
          onClick={() => setShowProjectPicker(!showProjectPicker)}
        >
          <div className="project-selector-left">
            <i className={`bi ${activeProject ? 'bi-folder-check' : 'bi-folder'}`}
               style={{ color: activeProject ? '#28a745' : 'rgba(255,255,255,0.5)', fontSize: '1.1rem' }}></i>
            <div className="project-selector-info">
              <div className="project-selector-label">Active Project</div>
              <div className="project-selector-name">
                {activeProject ? activeProject.project_name : 'No project selected'}
              </div>
            </div>
          </div>
          <i className={`bi bi-chevron-${showProjectPicker ? 'up' : 'down'}`}
             style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem' }}></i>
        </div>

        {showProjectPicker && (
          <div className="mobile-metro-project-list">
            {configuredProjects.map(p => {
              const isCurrentActive = activeProject?.project_id === p.project_id;
              return (
                <div
                  key={p.project_id}
                  className={`mobile-metro-project-option ${isCurrentActive ? 'active' : ''}`}
                  onClick={() => handleQuickActivateProject(p)}
                >
                  <i className={`bi ${isCurrentActive ? 'bi-check-circle-fill' : 'bi-circle'}`}
                     style={{ fontSize: '0.85rem', flexShrink: 0 }}></i>
                  <span className="project-option-name">{p.project_name}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    )}

    {/* Company Section (hidden for project-personnel-only) */}
    {projectPersonnelMenus.length === 0 && companyMenus.length > 0 && (
      <>
        <div className="mobile-metro-section-header">
          <div className="section-line"></div>
          <span className="section-label">COMPANY</span>
          <div className="section-line"></div>
        </div>
        <div className="mobile-metro-tiles">
          {companyMenus.map((menu, idx) => {
            const isChatOffline = menu.id === 'operations-chat' && !online;
            return (
            <div
              key={menu.id}
              className="mobile-metro-tile"
              style={{
                backgroundColor: menu.color,
                animationDelay: `${idx * 50}ms`,
                ...(isChatOffline ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : {})
              }}
              onClick={() => !isChatOffline && (menu.directPath ? handleNavigate(menu.directPath) : handleLevel1Click(menu.id))}
            >
              <menu.icon className="tile-icon" />
              <div className="tile-title">{menu.title}</div>
              {menu.id === 'inventory-field-entry' && (
                <div style={{ fontSize: '0.7rem', opacity: 0.88, marginTop: 2, lineHeight: 1.2 }}>
                  List · New asset
                </div>
              )}
              {menu.id === 'operations-chat' && hasUnreadOpsChat && (
                <span className="ops-chat-unread-dot mobile-metro-chat-dot" aria-label="Unread operations chat messages" />
              )}
            </div>
            );
          })}
        </div>
      </>
    )}

    {/* Project Section (hidden for project-personnel-only) */}
    {projectPersonnelMenus.length === 0 && projectMenus.length > 0 && (
      <>
        <div className="mobile-metro-section-header project">
          <div className="section-line"></div>
          <span className="section-label">PROJECT</span>
          <div className="section-line"></div>
        </div>
        <div className="mobile-metro-tiles">
          {projectMenus.map((menu, idx) => {
            const isChatOffline = menu.id === 'operations-chat' && !online;
            return (
            <div
              key={menu.id}
              className="mobile-metro-tile"
              style={{
                backgroundColor: menu.color,
                animationDelay: `${(companyMenus.length + idx) * 50}ms`,
                ...(isChatOffline ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : {})
              }}
              onClick={() => !isChatOffline && (menu.directPath ? handleNavigate(menu.directPath) : handleLevel1Click(menu.id))}
            >
              <menu.icon className="tile-icon" />
              <div className="tile-title">{menu.title}</div>
              {menu.id === 'inventory-field-entry' && (
                <div style={{ fontSize: '0.7rem', opacity: 0.88, marginTop: 2, lineHeight: 1.2 }}>
                  List · New asset
                </div>
              )}
              {menu.id === 'operations-chat' && hasUnreadOpsChat && (
                <span className="ops-chat-unread-dot mobile-metro-chat-dot" aria-label="Unread operations chat messages" />
              )}
            </div>
            );
          })}
        </div>
      </>
    )}
  </div>
);
}
